import { Stack, Text } from "@mantine/core";
import { ConfirmAndExecutePanel, EntityClientAction, FakeProgressBar } from "@mcurros2/microm";
import { PersonalTiendas } from "./PersonalTiendas";

export const ACTEliminarTienda: EntityClientAction = {
    name: 'ACTEliminarTienda',
    label: 'Eliminar Tienda',
    title: <Text fw={700}>Eliminar Tienda</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: ['plti_brwGestionTiendasPersonal'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        const abort_controller = new AbortController();

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as PersonalTiendas;

        await modal.open({
            modalProps: {
                title: <Text fw="700">{`Eliminar Tienda`}</Text>,
            },
            focusOnClosed: element,
            content:
                <ConfirmAndExecutePanel
                    operation="edit"
                    loadingContent={
                        <Stack>
                            <FakeProgressBar />
                            <Text size="sm" mb="xs">{`Eliminando tiendas`}</Text>
                        </Stack>
                    }
                    content={<Text size="sm" mb="xs">¿Desea eliminar las tiendas del personal?</Text>}
                    okButtonText="Aceptar"
                    onCancel={async () => {
                        await abort_controller.abort();
                        await modal.close();
                        if (onClose) await onClose();
                    }}
                    onOK={async () => {
                        const result = await parent.API.deleteData(selectedKeys, abort_controller.signal);

                        if (!result.Failed) {
                            if (onClose) await onClose();
                            await modal.close();
                        }

                    }}
                />
        });

        return false;
    }
}